import { atom } from 'jotai'
import { atomFamily } from 'jotai/utils'

import { alphamapClient } from 'src/clients'

export const rootEntities = atomFamily((entityId?: string) =>
  atom(async () => {
    if (!entityId) {
      return []
    }
    const entities = await alphamapClient.ownership.getRootEntitiesByEntityId(entityId)
    return entities
  })
)
